// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__pse8h","errors":"Errors_errors__3p_1Z"};